'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function Auth($http, $window, AppConstants, $cookieStore, $state) {
	'ngInject';

	var service = {
		login: login,
		logout: logout,
		refresh: refresh,
		isLoggedIn: isLoggedIn,
		isLoggedInAsync: isLoggedInAsync,
		getCurrentUser: getCurrentUser,
		setCurrentUser: setCurrentUser
	};

	var currentUser = {};

	return service;

	function login(user) {
		return $http.post(AppConstants.apiUrl + '/auth', user).then(success)['catch'](failedRequest);
	}

	/** LogOut user ad clead token from cookies	*/
	function logout() {
		$cookieStore.remove('token');
		currentUser = {};
		$state.go('app.public.login');
		// So as to clear all application cache
		$window.location.reload();
	}

	/** Refresh user token */
	function refresh(token) {
		return $http.post(AppConstants.apiUrl + '/auth-refresh', token).then(success)['catch'](failedRequest);
	}

	/** Succesful callback
  * @param { Object } response
  */
	function success(data) {

		if (!data.data.errors) {
			$cookieStore.put('token', data.data.data.token);
			setCurrentUser();
			$state.go('app.private.tickets.chooseSubLine');
		}

		return data;
	}

	/** Error handler on call back
  *	@param { Object } response
  */
	function failedRequest(response) {
		return response;
	}

	function getCurrentUser() {
		if (currentUser) {
			return currentUser;
		}
	}

	/** */
	function setCurrentUser(cb) {
		return $http.get(AppConstants.apiUrl + '/users/me').then(function (data) {
			var user = data.data.data.user;
			currentUser = user;
			isLoggedIn();
			cb;
		})['catch'](failedRequest);
	}

	function isLoggedIn() {
		return currentUser;
		// return currentUser.hasOwnProperty('id');
	}

	/**
  * Async check if the user is logged in
  * @param {Function} cb boolean is returned to this cb
  * @return {Boolean} is the user logged in
  */
	function isLoggedInAsync(cb) {
		if ($cookieStore.get('token')) {
			if (Object.keys(currentUser).length === 0) {
				setCurrentUser().then(function () {
					cb(true);
				})['catch'](function () {
					cb(false);
				});
			} else {
				cb(true);
			}
		} else {
			cb(false);
		}
	}
}

exports['default'] = Auth;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/auth/auth.service.js
 **/